import api from '../../../api';

// Email Settings API - SESUAI DENGAN BACKEND
export const getEmailSettings = async () => {
  try {
    const response = await api.get('/email/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching email settings:', error);
    throw error;
  }
};

export const updateEmailSettings = async (settings) => {
  try {
    console.log('API: Sending PUT request to /email/settings');
    console.log('API: Request data:', settings);
    
    const response = await api.put('/email/settings', settings);
    
    console.log('API: Response received:', response);
    console.log('API: Response data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('API: Error in updateEmailSettings');
    console.error('API: Error object:', error);
    console.error('API: Error response:', error.response);
    console.error('API: Error status:', error.response?.status);
    console.error('API: Error data:', error.response?.data);
    
    // Re-throw error dengan informasi yang lebih detail
    const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
    const enhancedError = new Error(`Failed to update email settings: ${errorMessage}`);
    enhancedError.originalError = error;
    enhancedError.response = error.response;
    
    throw enhancedError;
  }
};

export const testEmailSettings = async (testData) => {
  try {
    const response = await api.post('/email/settings/test', testData);
    return response.data;
  } catch (error) {
    console.error('Error testing email settings:', error);
    throw error;
  }
};

// Email Logs API - SUDAH SESUAI DENGAN BACKEND
export const getEmailLogs = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    // Sesuaikan parameter dengan backend
    if (params.page !== undefined) queryParams.append('page', params.page);
    if (params.size !== undefined) queryParams.append('size', params.size);
    if (params.status) queryParams.append('status', params.status);
    if (params.recipient) queryParams.append('recipient', params.recipient);
    if (params.subject) queryParams.append('subject', params.subject);
    if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
    if (params.dateTo) queryParams.append('dateTo', params.dateTo);
    
    const url = `/email/logs${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching email logs:', error);
    throw error;
  }
};

export const getEmailLog = async (id) => {
  try {
    const response = await api.get(`/email/logs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching email log:', error);
    throw error;
  }
};

export const deleteEmailLog = async (id) => {
  try {
    const response = await api.delete(`/email/logs/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting email log:', error);
    throw error;
  }
};

export const getEmailStats = async () => {
  try {
    const response = await api.get('/email/logs/stats');
    return response.data;
  } catch (error) {
    console.error('Error fetching email stats:', error);
    throw error;
  }
}; 